import gql from "graphql-tag";

export const MY_LEAVE_DETAILS_BY_CONTRACT = gql`
  query leaveDetailsByContract($contract: String!, $year: Int!) {
    leaveDetailsByContract(contract: $contract, year: $year) {
      baseLeaveDays
      onJobYears
      onAge
      onYoungAge
      onJobClass
      onManagerState
      onTrainerState
      onCountOfChildren
      onExposedToRadiationState
      onDoubleRiskState
      onPensionerState
      onBlindnessSate
      onStudy
      onJobGrade
      onAge50Years
      onESZJTV19
      onCovidPlus10
      onEmergency
      other
      onPreviousYear
      onPreviousYearBaseLeaves
      onPreviousYearAdditionalLeaves
      proportionalLeaveDays
      availableLeaveDays
      availableStudyLeaveDays
      availableESZJTV19LeaveDays
      availableCovidPlus10LeaveDays
      availableEmergencyLeaveDays
      fulfilledLeaveDays
      fulfilledStudyDays
      fulfilledAbsenceDays
      fulfilledESZJTV19Days
      fulfilledCovidPlus10Days
      fulfilledEmergencyDays
      _id
    }
  }
`;
